import { GET_MERCH_LIST } from './mutation-type'
 
 
export default {
    
}